import React from "react";
import { Modal } from "react-bootstrap";
import {  useProcessBillingsMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { MaintenanceFeeIcon } from "../../../../util/Icons";
import { formatLongDate } from "../../../../util/Helpers";


const ProcessBillingsModal = ({ showProcessBillingModal, onHide, autoId, created }) => {

    const [
        processBillings,
        {
            isLoading,
        }
    ] =  useProcessBillingsMutation()

    const process = () => {
        processBillings(autoId)
            .unwrap()
            .then(() => {
                cogoToast.success("Billing Process Initiated Successfully")
                onHide()
            })
    }


    return (
        <Modal
            show={showProcessBillingModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <MaintenanceFeeIcon />
                    </span>
                    Process Billing
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                <p>Are you sure you want to process billing for <strong>{autoId}</strong> for <strong>{formatLongDate(created)}</strong></p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isLoading}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                    onClick={process}
                >
                    Proceed
                </button>
            </Modal.Footer>
            
        </Modal>
    );
}

export default ProcessBillingsModal;